var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',{staticClass:"tw-rounded-lg tw-py-2 tw-px-4 tw-font-poppins tw-text-sm tw-opacity-30"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_vm._v(" "),_c('ul',{staticClass:"tw-flex tw-flex-col tw-gap-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }